import { isScheduleAndPayOrderWithPaymentPlan } from "src/services/api/orders";
import { IOrderDTO } from "../services/api";

export default function canDownloadPdfReceipt(o: IOrderDTO) {
  let payment;
  if (isScheduleAndPayOrderWithPaymentPlan(o)) {
    payment = o.payment_plan.installments.at(0)?.payment;
  } else payment = o.payment;
  return (
    ((o.final_price > 0 && payment?.status === "completed") ||
      (o.final_price === 0 && o.discount !== 0)) &&
    o.items.length > 0 &&
    (o.items[0].type === "upgrade_item" || o.items[0].type === "credit_item")
  );
}
